module.exports = __webpack_public_path__ + "img/p5.0446dedf.png";